// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__29wgO","detailsBorder":"styles_detailsBorder__Welrs"};